// Arama/filtre girdileri için tarayıcı otomatik doldurmasını engelleyen ortak
// nitelikler. Chrome `autoComplete="off"`u sık sık yok saydığı için AYRICA
// tanınmayan bir `name` kullanılır ("name/ad/isim/user/search" kalıplarından
// kaçınılır). Kimlik doğrulama alanlarında KULLANILMAZ — orada autofill kalsın.
export const noAutofill = (key) => ({
  autoComplete: "off",
  autoCorrect: "off",
  autoCapitalize: "off",
  spellCheck: false,
  name: `sx-q-${key}`,
  id: `sx-q-${key}`,
  "data-form-type": "other",
});

export default noAutofill;
